<div
  class="search"
  [class.theme-light]="theme === 'light'"
>
  <mat-form-field class="example-full-width">
    <mat-icon
      matPrefix
      [class.clickable]="searchMode === 'manual'"
      (click)="searchMode === 'manual' ? triggerSearch() : null"
    >
      search
    </mat-icon>
    <input
      type="text"
      matInput
      placeholder="{{ 'Search' | translate }}"
      [formControl]="field"
      (keyup.enter)="searchMode === 'manual' ? triggerSearch() : null"
    />
    <button
      *ngIf="(field.value ?? '').length > 0"
      mat-icon-button
      matSuffix
      type="button"
      (click)="clear()"
      [attr.aria-label]="'ClearSearch' | translate"
      [matTooltip]="'ClearSearch' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>
